import * as React from "react";
import { Toggletip } from "@grandvisionhq/lib-visuals";
import { useIntl } from "@grandvisionhq/state";
import { getProductTypeDeliveries } from "../../../../../../utils/utils/get-product-types-deliveries.js";
import { useDeliveryIndicator } from "../../../../../../contexts/DeliveryIndicator/contexts/DeliveryIndicator/context.js";
import { defaultDeliveryResolver } from "../../../../../../utils/utils/default-delivery-resolver.js";
import { getDeliveryEstimation } from "../../../../../../utils/utils/get-delivery-estimation.js";
import { DeliveryIndicator } from "../../../../components/modules/DeliveryIndicator/components/DeliveryIndicator.js";
const DEFAULT_AVAILABILITY = [];
const DeliveryIndicatorBasicContainer = ({
  view = "full",
  fallbackLabel,
  availability = DEFAULT_AVAILABILITY,
  deliveryResolver = defaultDeliveryResolver,
  productTypes,
  ...rest
}) => {
  const { getLabel, getFormattedLabel } = useIntl();
  const { config } = useDeliveryIndicator();
  if (availability?.length === 0 && (!productTypes || productTypes.size < 1) && !fallbackLabel) {
    return null;
  }
  let deliveries = [];
  if (productTypes && productTypes.size && config.productTypeDeliveryConfig) {
    deliveries = getProductTypeDeliveries(productTypes, config.productTypeDeliveryConfig) || deliveryResolver(config, availability);
  } else {
    deliveries = deliveryResolver(config, availability);
  }
  const deliveryEstimation = getDeliveryEstimation(
    deliveries,
    config?.missingInventoryChannelStrategy?.expectedDeliveryDays
  ) || "";
  const isNextDayDelivery = deliveryEstimation === "1";
  const labels = {
    deliveryIndication: getFormattedLabel("products.deliveryIndicator.shortDeliveryIndication", {
      labelData: { days: deliveryEstimation }
    })
  };
  let message = fallbackLabel || "";
  if (availability.length) {
    if (config.nextDayDeliveryTimeLimit && isNextDayDelivery) {
      message = `${getFormattedLabel("products.deliveryIndicator.deliveryNextDay", {
        labelData: { timeLimit: config.nextDayDeliveryTimeLimit }
      })}`;
    } else if (deliveryEstimation) {
      message = `${getFormattedLabel("products.deliveryIndicator.deliveryIndication", {
        labelData: { days: deliveryEstimation }
      })}`;
    }
  }
  return /* @__PURE__ */ React.createElement(
    DeliveryIndicator,
    {
      view,
      labels,
      deliveryMessage: message,
      tooltipSlot: /* @__PURE__ */ React.createElement(Toggletip, { message: getLabel("products.deliveryIndicator.deliveryTooltip") }),
      ...rest
    }
  );
};
export {
  DeliveryIndicatorBasicContainer
};
//# sourceMappingURL=DeliveryIndicatorBasic.js.map
